import React from "react";

import InfoModal from "../modals/InfoModal";
import logo from "/public/images/logo-mindhealth.png";

function Header() {
  return (
    <header className="grid grid-cols-3 items-center p-4 pb-6">
      <div className="flex justify-start">
        <img 
          src={logo}
          alt="MindHealth Logo" 
          className="h-12 w-auto"
        />
      </div>
      <div className="flex justify-center">
        <h1 className="font-[600]">Connect Your Mind</h1>
      </div>
      <div className="flex justify-end">
        <InfoModal />
      </div>
    </header>
  );
}

export default Header;
